// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2U-99","title":"nik_-","grouptitle":"_334Go","selected":"_3N3_q","group":"_2524w","groupitems":"mSEIQ","groupmask":"PARbL"};